import React from "react"
import DayPicker, { DateUtils } from "react-day-picker";
import moment from "moment";
import MomentLocaleUtils from "react-day-picker/moment";
import { Icon, Select, Button } from 'antd';
import Helmet from "react-helmet";

import "react-day-picker/lib/style.css";
import { 
    isSelected,
    isChecked, 
    periods, 
    months, 
    views, 
    leadtime_chart, 
    status_reserve, 
    days, 
    options_compare, 
    current_year, 
    past_year, 
    years_collection,
    past_years_collection,
    componentActive, 
    subComponentActive, 
    isPickupSection } from "../config/Helpers";


class FiltersTime extends React.Component{
  constructor(props){
    super(props);

    this.state = {
        active_week : 1,
        days_pickup : {
            base : 7,
            range : 7
        },
        request_status : "hide",
        module_menu_show : "hide",
        panel_menu_show : "hide",

        //Normal section
        datepicker : { from : undefined,  to : undefined },
        datepicker_comp : { from : undefined,  to : undefined },
        datepicker_aux : { from : undefined,  to : undefined },
        datepicker_comp_aux : { from : undefined,  to : undefined },
        
        //Special section (pickup)
        pickup : {
            _date : { from : undefined,  to : undefined },
            _date_aux : { from : undefined,  to : undefined },
            _date_comp : { from : undefined,  to : undefined },
            _date_comp_aux : { from : undefined,  to : undefined }
        },
        locale : "en",
        period_menu_show : "hide-panel",
        views_menu_show : "hide-panel",
        status_menu_show : "hide-panel",
        days_menu_show : "hide-panel",
        comp_menu_show : "hide-panel",
        years_menu_show : "hide-panel",
        dias_menu_show : "hide-panel",
        past_dias_menu_show : "hide-panel",
        compare_menu_options : "hide-panel",
        past_menu_years_show : "hide-panel",
        menu_chart_review : "hide-panel",
        menu_chart_reservation : "hide-panel",
        cust_menu_show : "hide", //[Pruebas] Debe ser "hide"
        datepicker_compare : "hide", //[Pruebas] Debe ser "hide"
        cont_datepicker : "hide", //[Pruebas] Debe ser "hide"
        period_show : "hide-panel",
        current_period : { key : "Año en curso", value : "current_year" },
        current_period_aux : { key : "Año en curso", value : "current_year" },
        current_view_review : { key : "Meses", value : "month" },
        current_year : { key : current_year(), value : current_year() },
        current_year_compare : { key : past_year(), value : past_year() },
        current_status : { key : "Reservation Date", value : "date_nights" },
        current_comp : { key : "Periodo anterior", value : 0 },
        current_option_compare : { key : "Por año", value : "past_year" },
        current_view_leadtime : { key : "Room Nigths", value : "room_night" },
        current_view_reservation : { key : "Room Nigths", value : "room_night" },
        month_select : new Date(current_year(),0),
        month_select_last : new Date(past_year(),0),
        from_month_current : new Date(current_year(),0),
        from_month_past : new Date(past_year(),0),
        to_month_current : new Date(current_year(),11),
        to_month_past : new Date(past_year(),11),
        years : years_collection(),
        past_years : past_years_collection(),
        year_active : current_year(),
        past_year_active : past_year(),
        active_days : {},
        request_status : "hide",
        views_columns : {
            0 : 'SEGMENT',
            1 : 'MARKET'
        }
    };

    this.handleDayClick = this.handleDayClick.bind(this);
    this.handleDayClickPast = this.handleDayClickPast.bind(this);
    this.handleResetClick = this.handleResetClick.bind(this);
    this.state.datepicker = this.getInitialState();
    this.state.datepicker_comp = this.getInitialState();
    this.state.setRangeCustom = this.setRangeCustom();
    this.state.changeDatesByYear = this.changeDatesByYear();
    this.getResetValues = this.getResetValues.bind(this)

    }   
    getResetValues(){
        return {
            active_week : 1,
            days_pickup : {
                base : 7,
                range : 7
            },
            request_status : "hide",
            module_menu_show : "hide",
            panel_menu_show : "hide",
            datepicker : { from : undefined,  to : undefined },
            datepicker_comp : { from : undefined,  to : undefined },
            datepicker_aux : { from : undefined,  to : undefined },
            datepicker_comp_aux : { from : undefined,  to : undefined },
            pickup : {
                _date : { from : undefined,  to : undefined },
                _date_aux : { from : undefined,  to : undefined },
                _date_comp : { from : undefined,  to : undefined },
                _date_comp_aux : { from : undefined,  to : undefined }
            },
            locale : "en",
            period_menu_show : "hide-panel",
            views_menu_show : "hide-panel",
            status_menu_show : "hide-panel",
            days_menu_show : "hide-panel",
            comp_menu_show : "hide-panel",
            years_menu_show : "hide-panel",
            dias_menu_show : "hide-panel",
            past_dias_menu_show : "hide-panel",
            compare_menu_options : "hide-panel",
            past_menu_years_show : "hide-panel",
            menu_chart_review : "hide-panel",
            menu_chart_reservation : "hide-panel",
            cust_menu_show : "hide", //[Pruebas] Debe ser "hide"
            datepicker_compare : "hide", //[Pruebas] Debe ser "hide"
            cont_datepicker : "hide", //[Pruebas] Debe ser "hide"
            period_show : "hide-panel",
            current_period : { key : "Año en curso", value : "current_year" },
            current_period_aux : { key : "Año en curso", value : "current_year" },
            current_view_review : { key : "Meses", value : "month" },
            current_year : { key : current_year(), value : current_year() },
            current_year_compare : { key : past_year(), value : past_year() },
            current_status : { key : "Reservation Date", value : "date_nights" },
            current_comp : { key : "Periodo anterior", value : 0 },
            current_option_compare : { key : "Por año", value : "past_year" },
            current_view_leadtime : { key : "Room Nigths", value : "room_night" },
            current_view_reservation : { key : "Room Nigths", value : "room_night" },
            month_select : new Date(current_year(),0),
            month_select_last : new Date(past_year(),0),
            from_month_current : new Date(current_year(),0),
            from_month_past : new Date(past_year(),0),
            to_month_current : new Date(current_year(),11),
            to_month_past : new Date(past_year(),11),
            years : years_collection(),
            past_years : past_years_collection(),
            year_active : current_year(),
            past_year_active : past_year(),
            active_days : {},
            request_status : "hide"
        }
    }
    getInitialState() {
        return {
            from: undefined,
            to: undefined,
        };
    }

    getDefaultValues(){
        return {
            current_view_preview    : { 
              key   : "Meses", 
              value : "month", 
            },
            current_period  : { 
              key   : "Año en curso", 
              value : "current_year" 
            },
            current_view_reservation   : { 
              key : "Room Nigths", 
              value : "room_night" 
            },
            current_view_leadtime   : { 
              key : "Room Nigths", 
              value : "room_night" 
            }, 
            cust_menu_show : "hide",
            datepicker_compare : "hide", 
            cont_datepicker : "hide",
            year_active : current_year(),
            past_year_active : past_year(),
            active_days : {},
            active_week : 1,
            days_pickup : {
                base : 7,
                range : 7
            },
            current_year : { 
              key : current_year(), 
              value : current_year() 
            },
            current_year_compare : { 
              key : past_year(), 
              value : past_year() 
            },
            current_option_compare : {
               key : "Por año", 
               value : "past_year" 
              }
          };
    }
    changeDatesByYear(type_select, value){
        let from_date_current   = new Date(value, 0),
            to_date_current     = new Date(value, 11),
            from_current        = this.state.datepicker.from !== undefined ? new Date(this.state.datepicker.from) : undefined,
            to_current          = this.state.datepicker.to !== undefined ? new Date(this.state.datepicker.to) : undefined,
            from_date_past      = new Date( value, 0),
            to_date_past        = new Date( value, 11),
            from_comp           = this.state.datepicker_comp.from !== undefined ? new Date(this.state.datepicker_comp.from) : undefined,
            to_comp             = this.state.datepicker_comp.to !== undefined ? new Date(this.state.datepicker_comp.to) : undefined,
            current_year_aux, comp_year_aux;
        
        if(type_select === "current"){
            current_year_aux = value;
            if(this.state.current_year_compare.value >= value){
                comp_year_aux = this.state.current_year_compare.value - 1;
            }else{
                comp_year_aux = this.state.current_year_compare.value;
            }   
        }else if(type_select === "compare"){
            comp_year_aux = value;
            if(this.state.current_year.value <= value){
                current_year_aux = this.state.current_year.value + 1;
            }else{
                current_year_aux = this.state.current_year.value;
            }  
        }
        if(from_current !== undefined){
            from_current.setFullYear(current_year_aux)
        }
        if(to_current !== undefined ){
            to_current.setFullYear(current_year_aux)    
        } 
        if(from_comp !== undefined){
            from_comp.setFullYear(comp_year_aux)
        }
        if(to_comp !== undefined ){
            to_comp.setFullYear(comp_year_aux)    
        } 

        from_date_current.setFullYear(current_year_aux)
        to_date_current.setFullYear(current_year_aux)
        
        from_date_past.setFullYear(comp_year_aux)
        to_date_past.setFullYear(comp_year_aux)

        this.setState(function(){
            return {
                year_active : current_year_aux,
                past_year_active : comp_year_aux,
                month_select : from_date_current,
                month_select_last : from_date_past,
                from_month_current : from_date_current,
                from_month_past : from_date_past,
                to_month_current : to_date_current,
                to_month_past : to_date_past,
                datepicker : {
                    from : from_current,
                    to : to_current
                },
                datepicker_comp : {
                    from : from_comp,
                    to : to_comp
                },
                current_year : { key : current_year_aux, value : current_year_aux },
                current_year_compare : { key : comp_year_aux, value : comp_year_aux }
            }
        })
    }
    setRangeCustom(value, _default = false){
        this.props.app.setState({
            period_filter : value
        });

        let from_current = new Date(),
        to_current = new Date(),
        from_past = new Date(),
        to_past = new Date();
        
        this.setState({
            year_active : (_default === true) ? current_year() : this.state.current_year,
            past_year_active : (_default === true) ? past_year() : this.state.past_year_active,
            current_year : { 
                key : (_default === true) ? current_year() : this.state.current_year.key, 
                value : (_default === true) ? current_year() : this.state.current_year.value 
            },
            current_year_compare : { 
                key : (_default === true) ? past_year() : this.state.current_year_compare.key, 
                value : (_default === true) ? past_year() : this.state.current_year_compare.value
            }
        }, function(){
            from_past.setFullYear(this.state.past_year_active)
            to_past.setFullYear(this.state.past_year_active)
        })
        

        if(value === "today")
        {
            this.setState({year_active  : current_year() })
        }
        else if(value === "yesterday"){
            from_current.setDate(from_current.getDate() - 1)
            to_current.setDate(to_current.getDate() - 1)     
            from_past.setDate(from_past.getDate() - 1)
            to_past.setDate(to_past.getDate() - 1);

            this.setState({year_active  : current_year() })
            
        }else if(value === "acm"){
            from_current = new Date(current_year(),0,1)        
            from_past = new Date((this.state.past_year_active),0,1)
            this.setState({year_active  : current_year() })

        }
        else if(value === "current_year"){
            from_current = new Date(current_year(), 0,1)
            to_current = new Date(current_year(), 11,31)          
            from_past = new Date((current_year() - 1), 0,1)
            to_past = new Date((current_year() - 1), 11,31)
            this.setState({year_active  : current_year() })
        }else if( value === "choice"){
            from_current = undefined;
            to_current = undefined;          
            from_past = undefined;
            to_past = undefined;
        }else if(value === "pickup"){
            let max_book_date = this.props.app.state.max_book_year_pickup;
            to_current = new Date(max_book_date);
            to_current.setDate(to_current.getDate());
            from_current = new Date(max_book_date);
            from_current.setDate(from_current.getDate() - (this.state.days_pickup.range - 1));  
            
            to_past = new Date(max_book_date)
            to_past.setFullYear(to_past.getFullYear() - 1);
            to_past.setDate(to_past.getDate());

            from_past = new Date(max_book_date);
            from_past.setFullYear(from_past.getFullYear() - 1);
            from_past.setDate(from_past.getDate() - (this.state.days_pickup.range - 1));

            this.setState({
                year_active : current_year(),
                cust_menu_show : "hide",
                period_show : "hide-panel", 
                datepicker_compare : "hide"
            })
        }
        if(value === "custom")
        {
            this.setState({
                cont_datepicker :   "",
                month_select :   to_current,
                month_select_last : to_past,
                current_year : { 
                    key : from_current.getFullYear(), 
                    value : from_current.getFullYear() 
                }
            }, function(){
                this.props.app.activeCustomCalendar(this.state.cont_datepicker);
            })
        }else if(value === "custom-aux")
        {
            this.props.app.hideSelects();
            let datepicker = Object.assign({}, this.state.datepicker_aux);
            let datepicker_comp = Object.assign({}, this.state.datepicker_comp_aux);
            if(this.state.cont_datepicker === ""){        
                this.state.datepicker = { to : new Date(datepicker.to), from : new Date(datepicker.from) }
                this.state.datepicker_comp = { to : new Date(datepicker_comp.to), from : new Date(datepicker_comp.from) }
            }
            let from_month_current = new Date(this.state.datepicker.from);
            from_month_current.setMonth(0);
            let to_month_current = new Date(this.state.datepicker.to);
            to_month_current.setMonth(11);
            let month_select = new Date(this.state.datepicker.from);
            
            this.setState({
                cont_datepicker : this.state.cont_datepicker === "" ? "hide" : "",
                month_select : month_select,
                cust_menu_show : this.state.cont_datepicker === "" ? "hide" : "",
                from_month_current : from_month_current,
                to_month_current : to_month_current,

            }, function(){
                this.props.app.activeCustomCalendar(this.state.cont_datepicker);
            })
        }else if(value !== "choice"){
            this.setState({
                cont_datepicker : "hide",
                datepicker : {
                    to : to_current,
                    from : from_current
                },
                datepicker_comp : {
                    to : to_past,
                    from : from_past
                },
                datepicker_aux : {
                    to : to_current,
                    from : from_current
                },
                datepicker_comp_aux : {
                    to : to_past,
                    from : from_past
                },
                current_period_aux : this.state.current_period
            }, function(){
                const years_compare = [ this.state.year_active, this.state.past_year_active]
                this.props.app.activeCustomCalendar(this.state.cont_datepicker);
                this.props.app.setFilterBubble([this.state.datepicker.from, this.state.datepicker.to, this.state.datepicker_comp.from, this.state.datepicker_comp.to], "time", null, this.state.active_days, years_compare);

            })
        }
    }
    handleDayClickPast(day) {
        let day_last_year = new Date(day);
        let year = day_last_year.getFullYear();
        let year_last = this.state.past_year_active;
        
        day_last_year.setFullYear(this.state.past_year_active)

        this.setState({ 
            month_select_last : new Date(year_last, day_last_year.getMonth())
        })
        if(this.state.current_period.key !== "Personalizado"){
            this.setState({
                current_period  : { key : "Personalizado", value : "custom"}, 
                datepicker_comp : { from : undefined,  to : undefined }
            }, () => {
                const range_comp = DateUtils.addDayToRange(day_last_year, this.state.datepicker_comp);
                this.setState({datepicker_comp : range_comp});
            });
        }else{
            
            const range_comp = DateUtils.addDayToRange(day_last_year, this.state.datepicker_comp);
            this.setState({datepicker_comp : range_comp});
        }
    }
    handleDayClick(day, modifiers = {} ) {
        let day_last_year = new Date(day);
        let year = day_last_year.getFullYear();   
        if(year < this.state.current_year.value || year > this.state.current_year.value){ return};
        day_last_year.setFullYear(this.state.past_year_active)
        this.setState({ 
            month_select : new Date(year, day_last_year.getMonth()),
        })
        if(this.state.current_period.key !== "Personalizado"){
            this.setState({
                current_period  : { key : "Personalizado", value : "custom"}, 
                datepicker : { from : undefined,  to : undefined },
            },function(){
                const range = DateUtils.addDayToRange(day, this.state.datepicker);
                this.setState({ datepicker : range });
            });
        }else{
            const range = DateUtils.addDayToRange(day, this.state.datepicker);
            this.setState({ datepicker : range });
        }
    }

    handleResetClick(){
        this.setState({ 
            datepicker : this.getInitialState(), 
            datepicker_comp : this.getInitialState()
        });
    }
    handleClickMenu(name) {
        let current_period = this.state.current_period
        if(name !== "dias_menu_show" && name !== "years_menu_show" && name !== "comp_menu_show" && name !== "past_menu_years_show" && name !== "compare_menu_options" && name !== "past_dias_menu_show"){
            this.props.app.hideSelects();
        }else if(name === "period_menu_show"){
            this.props.app.hideSelects("calendar_widget_active");
        }else{
            this.props.app.hideSelects("calendar_widget");
        }

        this.setState(function(){
            return { 
                [name] :  (this.state[name] === "hide-panel" ? "" : "hide-panel")
            }
        })
        
    }
    handleClickMenuItem(keyText, valueText, menu) {
        
        let $self = this;
        switch (menu) {
            case "period_menu":
                this.setState({ 
                    current_period : { 
                        key : keyText, value : valueText 
                    } 
                }, () => this.setRangeCustom(valueText))
            break;
            case "views_menu":
                this.setState({ 
                    current_view_review : { 
                        key : keyText, value : valueText 
                    } 
                }, () => $self.props.app.setViewList(valueText))
            break;
            case "reservation_chart_menu":
                this.setState({ 
                    current_view_reservation : { 
                        key : keyText, value : valueText 
                    } 
                }, () => $self.props.app.setViewList(valueText))
            break;

            case "leadtime_chart_menu":
                this.setState({ 
                    current_view_leadtime : { 
                        key : keyText, value : valueText 
                    } 
                }, () => $self.props.app.setViewList(valueText))
            break;
            case "status_menu":
                this.setState({
                    current_status : { 
                        key : keyText, value : valueText 
                    } 
                }, () => this.props.app.setTypeDateQuery(valueText))
            break;
            case "comp_menu":
                this.setState({
                    current_comp : { 
                        key : keyText, value : valueText 
                    } 
                })
            break;
            case "comp_year":
                this.changeDatesByYear('current', valueText)
            break;
            case "comp_past_year":
                this.changeDatesByYear('compare', valueText)
            break;
            case "custom_compare":
                this.setState({
                    current_option_compare : { key : keyText, value : valueText } 
                }, () => {
                    if(valueText === "custom_past_year"){
                        this.setState({ datepicker_compare : '' })
                    }else{
                        this.setState({ datepicker_compare : 'hide' })
                    }
                })
            break;
            case "days":
                let array_elements  = this.state.active_days

                if(array_elements[valueText] === undefined){
                    array_elements[valueText] = { day : keyText, value : valueText }
                }else{
                    delete array_elements[valueText];
                }
                this.setState({
                    active_days : array_elements,
                })
            break;
        }
    }

    handleClickApply(type){
        let condition;
        if(type !== "cancel" && type !== "hide-select"){
            if(this.state.current_option_compare.value !== "custom_past_year")
            {
                condition = (
                    this.state.datepicker.from !== undefined && 
                    this.state.datepicker.to !== undefined
                );
            }else{
                condition = (
                    this.state.datepicker.from !== undefined && 
                    this.state.datepicker.to !== undefined && 
                    this.state.datepicker_comp.from !== undefined && 
                    this.state.datepicker_comp.to !== undefined
                );
            }
            if(condition){
                if(isPickupSection(this.props.app)){
                    let to_past = new Date(this.state.datepicker.to)
                    to_past.setFullYear(past_year());
                    to_past.setDate(to_past.getDate());

                    let from_past = new Date(this.state.datepicker.from);
                    from_past.setFullYear(past_year());
                    from_past.setDate(from_past.getDate());

                    this.state.datepicker = this.state.datepicker
                    this.state.datepicker_aux = this.state.datepicker
                    this.state.datepicker_comp = { to : to_past, from: from_past}
                    this.state.datepicker_comp_aux = { to : to_past, from: from_past}

                    let moment_from = moment(this.state.datepicker.from)
                    let moment_to = moment(this.state.datepicker.to)

                    this.state.days_pickup = { 
                        range : (moment_to.diff(moment_from,"days") + 1), 
                        base : (moment_to.diff(moment_from,"days") + 1)
                    }
                    this.state.active_week  = 1;
                }
                this.setState({ 
                    period_show     : "hide-panel",
                    cust_menu_show  : "hide",
                    cont_datepicker  : "hide",
                    current_period_aux  :  { key : "Personalizado" , value: "custom" },
                    current_year :   { 
                        key     : this.state.datepicker.from.getFullYear(), 
                        value   : this.state.datepicker.from.getFullYear() 
                    },
                    current_year_compare :   { 
                        key     : this.state.datepicker_comp.from.getFullYear(), 
                        value   : this.state.datepicker_comp.from.getFullYear() 
                    },
                    year_active : this.state.datepicker.from.getFullYear(),
                    past_year_active : this.state.datepicker_comp.from.getFullYear()
                }, function(){
                    //const years_compare = [ this.state.year_active, this.state.past_year_active]
                    const years_compare = [ this.state.year_active, (this.state.year_active - 1)]
                    this.props.app.activeSecondaryBar("inactive");
                    this.props.app.activeCustomCalendar(this.state.cont_datepicker);
                    this.props.app.setFilterBubble([this.state.datepicker.from, this.state.datepicker.to, this.state.datepicker_comp.from, this.state.datepicker_comp.to], "time", null, this.state.active_days, years_compare);
                });
            }else{
                this.props.app.alertState("datepicker")
            }
        }else if(type === "cancel"){
            this.handleClickApply("hide-select")
            this.setState({
                cont_datepicker : 'hide'
            })
        }else if(type === "hide-select"){
            this.setState(function(prevState){
                const current_year = {
                    key : prevState.datepicker_aux.from.getFullYear(),
                    value :  prevState.datepicker_aux.from.getFullYear()
                }

                const past_year_active = prevState.datepicker_comp_aux.from.getFullYear()
                
                return { 
                    current_period  : prevState.current_period_aux,
                    datepicker      : prevState.datepicker_aux,
                    datepicker_comp : prevState.datepicker_comp_aux,
                    current_year : current_year,
                    past_year_active : past_year_active
                }
            }, () => this.props.app.activeCustomCalendar("hide"));
        }
    }

    handleClickFilterReset(type) {
        if(type === 2){
            if(this.state.cust_menu_show !== "hide"){
                this.setState({ 
                    period_show     : "hide-panel", 
                    cust_menu_show  : "hide" 
                }, () => this.props.app.activeCustomCalendar(this.state.cust_menu_show))
            }
            this.props.app.getInitialStatics("reset", 'present');
        }
    }

    handleClickShowCustomPeriods() {
        this.props.app.hideSelects();
        let temp_days       = Object.assign({}, this.props.app.current_filter_days);
        let cont_datepicker = this.state.current_period.value !== "custom" ? "hide" : ""; 
        if (this.state.period_show === "hide-panel"){
            this.props.app.activeSecondaryBar("active");
            this.setState({ 
                period_show         : "",
                cust_menu_show      : "",
                active_days         : temp_days
            }, () => this.props.app.activeCustomCalendar(this.state.cont_datepicker))
        }else{
            this.props.app.activeSecondaryBar("inactive");
            this.setState({ 
                period_show         : "hide-panel",
                cust_menu_show      : "hide",
                active_days         : {},
                cont_datepicker     : cont_datepicker,
            }, () => this.props.app.activeCustomCalendar("hide"))
        }
    }
    activeWeek(value){
        if(value !== this.state.active_week){
            const range = this.state.days_pickup.base * value;
            this.setState({
                days_pickup : {
                    range : range,
                    base : this.state.days_pickup.base
                },
                active_week : value
            }, function(){
                this.setPeriod('add')
            })
        }
    }
    validRange(value){
        if(value !== 1){
            let from_current = new Date(this.state.datepicker.from);
            from_current.setDate(from_current.getDate() - (this.state.days_pickup.base * value))
            if(from_current.getFullYear() !== this.props.app.state.current_year){
                return false;
            }
        }
        return true;        
    }
    getWeeks(){
        let weeks = [1,2,3,4].map((value) => (
            <span 
                className={ "week-select " + (this.state.active_week === value ? "active" : "") + (this.validRange(value) ? "" : " disabled") } 
                onClick={ () => { 
                    if(this.validRange(value)){ 
                        this.activeWeek(value)} 
                    } 
                } children={value} />
            )
        );
        return weeks;  
    }

    setPeriod(action){
        let datepicker = Object.assign({}, this.state.datepicker_aux);
        let datepicker_comp = Object.assign({}, this.state.datepicker_comp_aux);
        if(action === "prev"){
            datepicker.to.setDate(datepicker.to.getDate() - this.state.days_pickup.range);
            let to_current = new Date(datepicker.to);
            to_current.setDate(to_current.getDate() - this.state.days_pickup.range)
            datepicker.from = to_current;
            
            datepicker_comp.to.setDate(datepicker_comp.to.getDate() - this.state.days_pickup.range);
            let to_past = new Date(datepicker_comp.to);
            to_past.setDate(to_past.getDate() - this.state.days_pickup.range)
            datepicker_comp.from = to_past;

        }else if(action === "next"){
            datepicker.from = new Date(datepicker.to);
            datepicker.to.setDate(datepicker.to.getDate() + this.state.days_pickup.range);

            datepicker_comp.from = new Date(datepicker_comp.to);
            datepicker_comp.to.setDate(datepicker_comp.to.getDate() + this.state.days_pickup.range);
                        
            
        }else if(action === "add"){
            
            let from_current = new Date(datepicker.to)
            from_current.setDate(from_current.getDate() - this.state.days_pickup.range);  

            let from_past = new Date(datepicker_comp.to);
            from_past.setDate(from_past.getDate() - this.state.days_pickup.range);

            datepicker.from = from_current
            datepicker_comp.from = from_past
        }
        this.setState({
            datepicker : datepicker,
            datepicker_comp : datepicker_comp
        }, function(){
            const years_compare = [ this.state.year_active, this.state.past_year_active]
            this.props.app.setFilterBubble([this.state.datepicker.from, this.state.datepicker.to, this.state.datepicker_comp.from, this.state.datepicker_comp.to], "time", null, this.state.active_days, years_compare);

        })
    }

    jumpPeriodValid(type){
        if(type === "prev"){
            let from_current = new Date(this.state.datepicker.from)
            from_current.setDate(from_current.getDate() - this.state.days_pickup.range);  
            if(from_current.getFullYear() !== this.props.app.state.current_year){
                return " hide";
            }
        }else if(type === "next"){
            let to_current = new Date(this.state.datepicker.to)
            to_current.setDate(to_current.getDate() + this.state.days_pickup.range);  
            if(to_current.getFullYear() !== this.props.app.state.current_year){
                return " hide";
            }
        }
        return ""
    }
    setWeeks(year){

        let request_content = this.props.app.state.review_response_request, self = this;
        const _cy_weeks = (typeof(request_content.cy_weeks) !== "undefined") ? request_content.cy_weeks : {}
        const _ly_weeks = (typeof(request_content.ly_weeks) !== "undefined") ? request_content.ly_weeks : {}
        Object.keys(_cy_weeks).map((index) => {
            if(_cy_weeks[index].year === parseInt(year)){
                self.props.app.state.weeks_pickup = _cy_weeks[index].weeks;
                self.props.app.state.weeks_pickup_ly = _ly_weeks[index].weeks;
                self.props.app.state.current_week = _cy_weeks[index].weeks[0].value
                self.forceUpdate();
            }
        });    

        self.props.app.setState({
            year_pickup_future : year
        }, function(){
            self.props.app.mainRequest();
        })
    }
    render(){
        let self = this;
        const current_week = (this.props.app.state.current_week === null) ? 
            this.props.app.state.review_response_request.current_week : this.props.app.state.current_week;
        
        const ly_week = (this.props.app.state.weeks_pickup_ly[(current_week - 1)] !== undefined) ? 
            this.props.app.state.weeks_pickup_ly[(current_week - 1)].key : 0;
        
        const listPeriods = periods.map((item, index) =>
            <li key={"list-periods-reserve-" + index} className={isSelected(item.value, this.state.current_period.value)} 
                onClick={this.handleClickMenuItem.bind(this, item.key, item.value,  "period_menu")}>
                {item.key}
            </li>
        );

        const listStatusReserve = status_reserve.map((item, index) =>
            <li key={"list-status-reserve-" + index} className={isSelected(item.value, this.state.current_status.value)} 
                onClick={this.handleClickMenuItem.bind(this, item.key, item.value,  "status_menu")}>
                {item.key}
            </li>
        );

        const listViews = views.map((item, index) =>
            <li key={"list-views-" + index} className={isSelected(item.value, this.state.current_view_review.value)} 
                onClick={this.handleClickMenuItem.bind(this, item.key, item.value,  "views_menu")}>
                {item.key}
            </li>
        );
        const listReservationViews = leadtime_chart.map((item, index) =>
            <li key={"list-reservation-" + index} className={isSelected(item.value, this.state.current_view_review.value)} 
                onClick={this.handleClickMenuItem.bind(this, item.key, item.value,  "reservation_chart_menu")}>
                {item.key}
            </li>
        );

        const listLeadtimeViews = leadtime_chart.map((item, index) =>
            <li key={"list-leadtime-" + index} className={isSelected(item.value, this.state.current_view_review.value)} 
                onClick={this.handleClickMenuItem.bind(this, item.key, item.value,  "leadtime_chart_menu")}>
                {item.key}
            </li>
        );


        const Option = Select.Option;
        let request_content = this.props.app.state.review_response_request;

        const _cy_weeks = (typeof(request_content.cy_weeks) !== "undefined") ? request_content.cy_weeks : {}
        const _ly_weeks = (typeof(request_content.ly_weeks) !== "undefined") ? request_content.ly_weeks : {}
        const listYearsSelectPickup = Object.keys(_cy_weeks).map((index) => {
            self.props.app.state.weeks_pickup = _cy_weeks[index].weeks;
            self.props.app.state.weeks_pickup_ly = _ly_weeks[index].weeks;
            return (
                <Option key={ _cy_weeks[index].year }>
                    { _cy_weeks[index].year }
                </Option>
            )
        });    

        const listYearsSelect = Object.keys(this.state.years).map((index) =>
            <Option key={this.state.years[index]}>
                {this.state.years[index]}
            </Option>
        );

        let weeks = this.props.app.state.weeks_pickup;

        const listWeekSelect = Object.keys(weeks).map((index) =>
            <Option value={weeks[index].value} key={weeks[index].value}>
                {weeks[index].key}
            </Option>
        );
        let viewsColumns = this.state.views_columns;
        const views_columns = Object.keys(viewsColumns).map((index) =>
            <Option key={viewsColumns[index]}>
                { viewsColumns[index] }
            </Option>
        );
        
        /*const listYears= this.state.years.map((item, index) =>
            <li key={"list-year-" + index} className={isSelected(item, this.state.current_year.value)} 
                onClick={this.handleClickMenuItem.bind(this, item, item,  "comp_year")}>
                {item}
            </li>
        );
        const listYearsCompare= this.state.past_years.map((item, index) =>
            <li key={"list-year-compare-" + index} className={isSelected(item, this.state.current_year_compare.value)} 
                onClick={this.handleClickMenuItem.bind(this, item, item,  "comp_past_year")}>
                {item}
            </li>
        );
        const listDias = days.map((item, index) =>
            <li key={"list-days-" + index}>
                <span>{item.key}</span>
                <input type="checkbox" 
                    value={ item.value }
                    checked={isChecked(this.state.active_days, item.value)} 
                    onClick={this.handleClickMenuItem.bind(this, item.key, item.value, "days")}
                />
                <span className="checkmark"></span>
            </li>
        );
        const listOptionsCompare = options_compare.map((item, index) =>
            <li key={"list-options-" + index} className={isSelected(item.value, this.state.current_view_review.value)} 
                onClick={this.handleClickMenuItem.bind(this, item.key, item.value,  "custom_compare")}>
                {item.key}
            </li>
        );*/
        if(this.state.datepicker.from !== undefined){
            var dateFormatFrom = new Date(this.state.datepicker.from);
            dateFormatFrom = dateFormatFrom.getFullYear() + "/" + months[dateFormatFrom.getMonth()] +  "/" + dateFormatFrom.getDate();
        }
        if(this.state.datepicker.to !== undefined){   
            var dateFormatTo = new Date(this.state.datepicker.to);
            dateFormatTo = dateFormatTo.getFullYear() + "/" + months[dateFormatTo.getMonth()] +  "/" + dateFormatTo.getDate();
        }
        let select_years = (
            <Select
                showSearch={false}
                style={{ width: 100 }}
                value={this.state.current_year.value}
                onChange={ (value) => {
                    self.changeDatesByYear('current', value)
                }}
                children={listYearsSelect}
            />
        )
        let select_years_pickup = (
            <Select
                showSearch={false}
                value={this.props.app.state.year_pickup}
                style={{fontSize : 12}}
                onChange={ (value) => {
                    this.props.app.setState({
                        year_pickup : value
                    }, function(){
                        self.setWeeks(value)
                    })
                }}
                children={listYearsSelectPickup}
            />
        )
        let select_week = (
            <Select
                showSearch={false}
                value={(this.props.app.state.current_week === null) ? this.props.app.state.review_response_request.current_week : this.props.app.state.current_week}
                style={{width : 'auto', fontSize : 12}}
                onChange={ (value) => {
                    self.props.app.setState({
                        current_week : value
                    }, function(){
                        self.props.app.mainRequest();
                    })
                }}
                children={listWeekSelect}
            />
        )

        let select_view_column = (
            <Select
                showSearch={false}
                defaultActiveFirstOption={true}
                value={self.props.app.state.review_table_filter}
                style={{
                    display : 'inline-block', 
                    verticalAlign : 'middle', 
                    fontSize : '12px', 
                    width : '120px'
                }}
                onClick={ () => {
                    //this.props.app.handleClickFilterPace.bind(this)
                    //this.props.app.showModalUpgradeVersion();
                }}
                onChange={(value) => {
                    this.props.app.showModalUpgradeVersion();
                }}
                children={views_columns}
            />
        )
        if(this.props.app.isInvitedUser()) {
            return(
                <div className="filters-period-block">
                    <section className="filters-period">
                        <div className="panel-filters">
                            <div className={"request-load " + this.state.request_status}>
                                <Icon type="sync" spin />
                            </div>
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-md-9"> 
                                        <div>
                                            {
                                                subComponentActive(this.props.app, "pickup") === " hide" ? 
                                                (<div className={"pickup-dates "}>
                                                    <span onClick={this.setPeriod.bind(this, "prev")} className={subComponentActive(this.props.app, "pickup") + " arrow " + this.jumpPeriodValid("prev")} children="<"/>
                                                    <div className="date-period">
                                                        <div className="DayPickerInput">
                                                            <input onClick={this.setRangeCustom.bind(this,"custom-aux")} readOnly="readOnly" placeholder={dateFormatFrom} ref="PickerFrom" />
                                                        </div>
                                                    </div>
                                                    <div className="date-period">
                                                        <div className="DayPickerInput">
                                                            <input onClick={this.setRangeCustom.bind(this,"custom-aux")} readOnly="readOnly" placeholder={dateFormatTo} ref="PickerFrom" />
                                                        </div>
                                                    </div>
                                                    <div className={"split-filters " + componentActive(this.props.app, ["review", "lead-time", "reservation"])} children={ "  " } />
                                                    <span onClick={this.setPeriod.bind(this, "next")} className={subComponentActive(this.props.app, "pickup") + " arrow " + this.jumpPeriodValid("next")} children=">"/>
                                                </div>) : 
                                                <div className="pickup-weeks">
                                                    <span className="year-pickup" style={{fontSize : 12}}>YEAR: </span> 
                                                    {select_years_pickup}
                                                    <div className="select-view-column" style={{color : '#4da1ff', marginLeft : '5px'}}>
                                                        <Icon type="double-right"/>
                                                    </div>
                                                    <span className="week-year" style={{fontSize : 12}}>WEEK: </span> 
                                                    {select_week}
                                                    <div className="select-view-column" style={{color : '#4da1ff', marginLeft : '5px'}}>
                                                        VS
                                                    </div>
                                                    <span style={{paddingLeft : 5, fontWeight : 300}}>{ly_week}</span>
                                                    {/* <Button 
                                                    style={{marginLeft : 15}} 
                                                    type="primary"
                                                    onClick={() => {
                                                        this.props.app.mainRequest()
                                                    }} 
                                                    children="APPLY" /> */}
                                                </div>
                                            }
                                            {
                                                (
                                                    componentActive(this.props.app, ["review"]) !== ' hide' &&
                                                    subComponentActive(this.props.app, "pickup") === " hide" && 
                                                    this.props.app.state.filter_column_custom === true   
                                                ) ?
                                                <div className="select-view-column">
                                                    <Icon type="double-right" style={{color : '#4da1ff', marginRight : '5px'}}/> {select_view_column}
                                                </div> : ""
                                            }
                                            {/*<div className={"weeks-pickup " + subComponentActive(this.props.app, "pickup") }>
                                                <span className="title">Accumulate:</span>
                                                { this.getWeeks() } 
                                                <span className="title"> x Interval of {this.state.days_pickup.base}</span>
                                            </div> */}

                                            {/*<div className={"select-style type-two " + this.state.menu_chart_reservation + componentActive(this.props.app, ["reservation"]) } onClick={this.handleClickMenu.bind(this, "menu_chart_reservation")}>
                                                <span className="input-filters select blue custom-period">
                                                    <span title={this.state.current_view_reservation.key}>{this.state.current_view_reservation.key}</span>
                                                    <ul>
                                                        {listReservationViews}
                                                    </ul>
                                                </span>
                                            </div>

                                            <div className={"select-style type-two " + this.state.menu_chart_review + componentActive(this.props.app, ["lead-time"]) } onClick={this.handleClickMenu.bind(this, "menu_chart_review")}>
                                                <span className="input-filters select blue custom-period">
                                                    <span title={this.state.current_view_leadtime.key}>{this.state.current_view_leadtime.key}</span>
                                                    <ul>
                                                        {listLeadtimeViews}
                                                    </ul>
                                                </span>
                                            </div> 
                                            <div className={"select-style type-two " + this.state.status_menu_show + componentActive(this.props.app, ["review"]) } onClick={this.handleClickMenu.bind(this, "status_menu_show")}>
                                                <span className="input-filters select blue custom-period">
                                                    <span title={this.state.current_status.key}>{this.state.current_status.key}</span>
                                                    <ul>
                                                        {listStatusReserve}
                                                    </ul>
                                                </span>
                                            </div>*/}
                                        </div>
                                    </div>
                                    <div className="col-md-3 to-align-right">
                                        <div className={"btn-show-style " + componentActive(this.props.app, ["review"])} 
                                            onClick={ () => {
                                                //this.props.app.handleClickFilterPace.bind(this)
                                                this.props.app.showModalUpgradeVersion();
                                            }}>
                                            <span className={this.props.app.state.filter_by_pace === 1 ? "active" : ""}>
                                                { this.props.app.state.filter_by_pace !== 1 ? "PACE %" : "BUDGET" }
                                            </span>
                                        </div>
                                        <div className="btn-show-style" onClick={this.handleClickFilterReset.bind(this, 2)}>
                                            <span className={"no-margin-right"} children="RESTORE"/>
                                        </div>
                                    </div>                            
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className={"filters-period second-row " + this.state.cust_menu_show}>
                        <div className="panel-filters">
                            <div className={"container-datepicker " + this.state.cont_datepicker + (isPickupSection(this.props.app) ? " pickup-datepicker" : "") } ref={ref => { this.container_datepicker = ref }}>
                                <div className="current-year">
                                    <div className="container-calendar">
                                        {/*<div className="options">
                                            <div className={"select-style type-two " + this.state.years_menu_show} onClick={this.handleClickMenu.bind(this, "years_menu_show")}>
                                                <span className="input-filters select blue custom-period">
                                                    <span title={this.state.current_year.key}>{this.state.current_year.key}</span>
                                                    <ul>
                                                        {listYears}
                                                    </ul>
                                                </span>
                                            </div>
                                            <div className={"select-style type-two " + this.state.dias_menu_show + componentActive(this.props.app, ["review", "occupancy", "lead-time", "reservation"]) }>
                                                <div onClick={this.handleClickMenu.bind(this, "dias_menu_show")} className="select-days"></div>
                                                <span className="input-filters select blue custom-period">
                                                    <span>Days</span>
                                                    <ul>
                                                        {listDias}
                                                    </ul>
                                                </span>
                                            </div>
                                        </div>*/ }
                                        <div className="datepicker-wdg">
                                            <DayPicker 
                                                className="Selectable"
                                                numberOfMonths={3}
                                                pagedNavigation fixedWeeks
                                                localeUtils={MomentLocaleUtils} 
                                                locale="en"
                                                month={this.state.month_select}
                                                fromMonth={this.state.from_month_current}
                                                toMonth={this.state.to_month_current}
                                                selectedDays={[this.state.datepicker.from, { from : this.state.datepicker.from, to : this.state.datepicker.to }]}
                                                modifiers={ { start : this.state.datepicker.from, end : this.state.datepicker.to } }
                                                onDayClick={this.handleDayClick}
                                            />
                                            
                                        </div>
                                        <div className={"options-compare"}>
                                            <div className="second-block">
                                                <span className="active-year">ACTIVE YEAR</span>
                                                {select_years}
                                                <button onClick={this.handleClickApply.bind(this, "days_menu_show")} className="btn-submit">APPLY</button> 
                                                <button onClick={this.handleClickApply.bind(this, "cancel")} className="btn-submit">CANCEL</button>

                                                {/*<div className="compare-condition hide">
                                                    <input type="checkbox"  value={ "comparar" } />
                                                    <span className="checkmark"></span>
                                                    <span>Comparar: </span>
                                                </div>
                                                <div className={"select-style type-two " + this.state.compare_menu_options + componentActive(this.props.app, ["review"]) } onClick={this.handleClickMenu.bind(this, "compare_menu_options")}>
                                                    <span className="input-filters select blue custom-period">
                                                        <span title={this.state.current_option_compare.key}>{this.state.current_option_compare.key}</span>
                                                        <ul>
                                                            {listOptionsCompare}
                                                        </ul>
                                                    </span>
                                                </div>
                                                <div className={"compare-condition year_compare" + componentActive(this.props.app, ["review"]) }>
                                                    <span>Años a comparar: </span>
                                                </div>
                                                <div className={"select-style type-two " + this.state.past_menu_years_show + componentActive(this.props.app, ["review"]) } onClick={this.handleClickMenu.bind(this, "past_menu_years_show")}>
                                                    <span className="input-filters select blue custom-period">
                                                        <span title={this.state.current_year_compare.key}>{this.state.current_year_compare.key}</span>
                                                        <ul>
                                                            {listYearsCompare}
                                                        </ul>
                                                    </span>
                                                </div>*/}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { /*<div className={"comp-year " + this.state.datepicker_compare + " " + componentActive(this.props.app, ["review"])}>
                                    <div className="container-calendar">
                                        <div className="options">
                                            <h3>COMPARATIVA</h3>
                                            
                                            <div className={"select-style type-two " + this.state.past_dias_menu_show}>
                                                <div onClick={this.handleClickMenu.bind(this, "past_dias_menu_show")} className="select-days"></div>
                                                <span className="input-filters select blue custom-period">
                                                    <span>Days</span>
                                                    <ul>
                                                        {listDias}
                                                    </ul>
                                                </span>
                                            </div>
                                        </div>
                                        <div className="datepicker-wdg">
                                            <DayPicker 
                                                className="Selectable last-year"
                                                numberOfMonths={3}
                                                month={this.state.month_select_last}
                                                fromMonth={this.state.from_month_past}
                                                toMonth={this.state.to_month_past}
                                                pagedNavigation fixedWeeks
                                                localeUtils={MomentLocaleUtils} 
                                                locale="en"
                                                selectedDays={[this.state.datepicker_comp.from, { from : this.state.datepicker_comp.from, to : this.state.datepicker_comp.to }]}
                                                modifiers={ { start : this.state.datepicker_comp.from, end : this.state.datepicker_comp.to } }
                                                onDayClick={this.handleDayClickPast}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={"container-fluid " + componentActive(this.props.app, ["review", "occupancy", "lead-time", "reservation"])}>
                                <div className="row">
                                    <div className="col-md-6 ">
                                        
                                        { /*<div className={"date-period " + componentActive(this.props.app, ["review", "occupancy", "lead-time", "reservation"])}>
                                            <div className="DayPickerInput">
                                                <input readOnly="readOnly" placeholder={dateFormatFrom} />
                                            </div>
                                        </div>
                                        <div className="to-date"> - </div>
                                        <div className={"date-period"}>
                                            <div className="DayPickerInput">
                                                <input readOnly="readOnly" placeholder={dateFormatTo} />
                                            </div>
                                    </div> 
                                    </div>
                                </div> */ }
                            </div>
                        </div>
                    </section>
                    <Helmet>
                <style>{`
                    .Selectable .DayPicker-Day--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(.DayPicker-Day--outside) {
                        background-color: #cae3ff !important;
                        color: #8b9898;
                    }
                    .Selectable.last-year .DayPicker-Day--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(.DayPicker-Day--outside) {
                        background-color: #ffdea8 !important;
                        color: #8b9898;
                    }
                    .Selectable.last-year .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside){
                        background-color: #ffbe54;
                    }
                    .Selectable .DayPicker-Day {
                        border-radius: 0 !important;
                        padding: 5px;
                        font-size: 12px;
                        color: #8b9898;
                    }
                    .Selectable .DayPicker-Month{
                        border-radius: 2px;
                        margin: 7px;
                        border: solid 1px #e4f1ff;
                    }
                    .Selectable .DayPicker-Day--outside{
                        color: #eee;
                    }
                    .Selectable .DayPicker-Caption{
                        font-size: 12px;
                        text-align: center;
                        color: #4da1ff;
                        letter-spacing: 2px;
                    }
                    .Selectable .DayPicker-Weekday{
                        padding: 10px 11px;
                        font-size: 12px;
                        text-transform: uppercase;
                    }
                    .Selectable .DayPicker-Caption > div{
                        font-size:12px;
                        text-transform: uppercase;
                    }
                    .Selectable .DayPicker-Day--start {
                        border-top-left-radius: 20px !important;
                        border-bottom-left-radius: 20px !important;
                    }
                    .Selectable .DayPicker-Day--end {
                        border-top-right-radius: 20px !important;
                        border-bottom-right-radius: 20px !important;
                    }
                    .Selectable .DayPicker-wrapper{
                        padding-left: 20px;
                        padding-right: 20px;
                    }
                    .Selectable .DayPicker-NavButton--prev{
                        top: 130px;
                        width: 20px;
                        height: 20px;
                        left: 10px;
                        color: #4da1ff;
                    }
                    .Selectable .DayPicker-NavButton--next{
                        top: 130px;
                        width: 20px;
                        height: 20px;
                        right: 10px;
                        color: #4da1ff;
                    }
                    `}</style>
                </Helmet>
            </div>
        )}else{
            return (<div></div>);
        }
    }
};


export default FiltersTime



// WEBPACK FOOTER //
// ./src/Frontend/components/FiltersTime.js